/** @jsxRuntime classic */ // <-- remove this when TS updated to 4.1
/** @jsx jsx */ // <-- remove this when TS updated to 4.1
import { jsx } from '@emotion/core';
import { useTheme } from 'emotion-theming';
import ReactMarkdown from 'react-markdown';
import RemarkBreaks from 'remark-breaks';
import { Text } from '../..';
import { ThemeProps } from '../../../types';

export interface MarkdownProps {
  /**
   * The react child to render
   */
  children: any;
  /**
   * The css class for the input. Handled internally by emotion
   */
  className?: string;
  /**
   * Extend the default renderer by component with this prop
   */
  customRenderer?: object;
}

const Markdown = ({ children, className, customRenderer }: MarkdownProps) => {
  const theme: ThemeProps = useTheme();

  const renderers: any = {
    heading: ({ level, ...rest }: any) => {
      return (
        <Text {...rest} variant={`h${level}`} element='p' weight='heavy' />
      );
    },
    link: ({ children, ...rest }: any) => {
      return (
        <a {...rest} target='_blank'>
          {children}
        </a>
      );
    },
    strong: ({ children }: any) => (
      <strong css={{ fontWeight: theme.fonts.weights.bold }}>{children}</strong>
    ),
  };
  return (
    <ReactMarkdown
      children={children}
      className={className}
      renderers={{ ...renderers, ...customRenderer }}
      plugins={[RemarkBreaks]}
    />
  );
};

export default Markdown;
